<div>
    <ag-grid-angular #agGrid style="height: 40rem;" class="ag-theme-sg-bootstrap-condensed" [gridOptions]="gridOptions!"
      [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" [rowData]="eCashPayments" [sideBar]="sideBar"
      (gridReady)="onGridReady($event)" rowSelection="single">
    </ag-grid-angular>
    <h5>Count: {{rowCount}} </h5>
  </div>